import React, { useState } from 'react';
import { NavbarContent, NavbarMenuToggle, NavbarMenu, NavbarMenuItem, Link } from '@nextui-org/react';
// import Link from './Link';
import { ChevronDown } from './Icons';
import { navItems } from './NavbarData';
import styles from './styles/navbar.module.css';

export default function NavbarMobile({ isMenuOpen }: { isMenuOpen: boolean; handleMenuOpenChange: (isOpen: boolean) => void }) {
    const [openDropdown, setOpenDropdown] = useState('');

    const handleDropdownToggle = (key: string) => {
        setOpenDropdown(openDropdown === key ? '' : key);
    };

    return (
        <>
            <NavbarContent justify="end" className="xl:hidden">
                <NavbarMenuToggle className="text-gray-50" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} />
            </NavbarContent>
            <NavbarMenu className={styles.mobilenav}>
                {navItems.map((item) =>
                    item.dropdown ? (
                        <React.Fragment key={item.key}>
                            <NavbarMenuItem>
                                <Link color="foreground" className="w-full flex items-center justify-between" href="#" onClick={() => handleDropdownToggle(item.key)}>
                                    {item.label}
                                    <ChevronDown className={`transition-transform ${openDropdown === item.key ? 'transform rotate-180' : ''}`} fill="currentColor" size={16} height={16} width={16} props={undefined} />
                                </Link>
                            </NavbarMenuItem>
                            {openDropdown === item.key && (
                                <div className="ml-4">
                                    {item.dropdown.map((dropdownItem) => (
                                        <NavbarMenuItem key={dropdownItem.key}>
                                            <Link color="foreground" className="w-full" href={`${dropdownItem.link}`}>
                                                {dropdownItem.label}
                                            </Link>
                                        </NavbarMenuItem>
                                    ))}
                                </div>
                            )}
                        </React.Fragment>
                    ) : (
                        <NavbarMenuItem key={item.key}>
                            <Link color="foreground" className="w-full" href={`${item.link}`}>
                                {item.label}
                            </Link>
                        </NavbarMenuItem>
                    )
                )}
            </NavbarMenu>
        </>
    );
}
